var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.625C9.30023 0.625 0.625 9.30336 0.625 20C0.625 30.7029 9.30023 39.375 20 39.375C30.6998 39.375 39.375 30.7029 39.375 20C39.375 9.30336 30.6998 0.625 20 0.625ZM20 35.625C11.3647 35.625 4.375 28.6382 4.375 20C4.375 11.3676 11.365 4.375 20 4.375C28.6321 4.375 35.625 11.3649 35.625 20C35.625 28.6352 28.6382 35.625 20 35.625ZM28.3784 15.6875C28.3784 20.9259 22.7205 21.0066 22.7205 22.9424V23.4375C22.7205 23.9552 22.3008 24.375 21.783 24.375H18.2169C17.6991 24.375 17.2794 23.9552 17.2794 23.4375V22.761C17.2794 19.9684 19.3966 18.8521 20.9965 17.9551C22.3684 17.1859 23.2093 16.6628 23.2093 15.6442C23.2093 14.2969 21.4906 13.4026 20.1012 13.4026C18.2895 13.4026 17.4532 14.2602 16.2776 15.7439C15.9606 16.1439 15.3823 16.2182 14.9755 15.9098L12.8018 14.2616C12.4028 13.9591 12.3134 13.397 12.5952 12.9832C14.4411 10.2727 16.7922 8.75 20.4527 8.75C24.2863 8.75 28.3784 11.7425 28.3784 15.6875V15.6875ZM23.2812 28.75C23.2812 30.5593 21.8093 32.0312 20 32.0312C18.1907 32.0312 16.7188 30.5593 16.7188 28.75C16.7188 26.9407 18.1907 25.4688 20 25.4688C21.8093 25.4688 23.2812 26.9407 23.2812 28.75Z",
    fill: "#EFC155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.774d2a0bee5f99e8bbaf4beae372f7e1.svg";
export { ForwardRef as ReactComponent };